import "./clientscroll.css";

const ClientScroll = () => {
  const clients = [
    "Byyizzy",
    "SLR Public School",
    "Byyizzy",
    "SLR Public School",
  ];

  return (
    <section id="testimonials" className="testimonials">
      <div className="container">
        {/* Client Logos Slider */}
        <div className="clients-logo-section" data-aos="fade-up">
          <h3 className="clients-title">Trusted by Leading Customer</h3>

          <div className="clients-logo-slider">
            <div className="logo-track">
              {/* First set */}
              {clients.map((client, index) => (
                <div key={`client-${index}`} className="client-logo-item">
                  {client}
                </div>
              ))}

              {/* Duplicate for infinite scroll */}
              {clients.map((client, index) => (
                <div key={`client-dup-${index}`} className="client-logo-item">
                  {client}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="testimonials-shape"></div>
    </section>
  );
};

export default ClientScroll;
